import { useUser } from "../contexts/UserContext";
import { USER_TYPES } from "../types/userType";

const useIsRental = () => {
  const { userType } = useUser();
  
  // userType can be a string (single) or array (multiple roles)
  if (!userType) return false;
  if (Array.isArray(userType)) {
    return userType.includes(USER_TYPES.RENTAL);
  }
  return userType === USER_TYPES.RENTAL;
};

export default useIsRental;
